import { useQuery } from "@tanstack/react-query"
import { fetcher } from "../fetcher"
import { useNavigationContext } from "../../hooks"

export type DebitAuthListResponse = {
  debitAuths: {
    enabled: boolean
    preAuthLimit: number
    companyName: string
    companyId: {
      value: string
    }
    debitAuthId: {
      value: string
    }
    status: string
  }[]
}

export function useDebitAuthList() {
  const { isLoggedIn } = useNavigationContext()

  return useQuery<DebitAuthListResponse>({
    queryKey: ["DebitAuth/List"],
    queryFn: async () => {
      const response = await fetcher(
        "/DebitAuth/List",
        {
          method: "GET",
        },
        {
          useAccessToken: true,
        }
      )
      const responseJson = await response.json()

      return responseJson
    },
    enabled: isLoggedIn,
  })
}
